import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchProcessingAgencyComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getAllProcessingAgencyCombo from '../../services/processingAgency/getAllProcessingAgencyCombo'

export function * fetchProcessingAgencyCombo ({ organizedUnitId }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const processingAgencies = yield call(getAllProcessingAgencyCombo, auth.token, organizedUnitId)
    yield put(fetchProcessingAgencyComboSuccess(processingAgencies))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchProcessingAgencyCombo () {
  yield takeLatest(combosActionTypes.FETCH_PROCESSING_AGENCY_COMBO, fetchProcessingAgencyCombo)
}
